// Query-key factory for the staff notification dispatch diagnostics.
//
// Required by the stale-after-save gate (`src/test/staleAfterSaveGate.test.ts`):
// every `queryKey: [...]` array literal must live in a `*Keys` factory file.
// `NotificationPreferencesPage` carries a grandfathered baseline of exactly two
// inline literals, and that baseline is shrink-only — so the diagnostics read
// gets a factory rather than a third literal there.

/**
 * Why staff notification email did or did not go out over a recent window.
 *
 * Read-only and ADMIN-gated server-side, so nothing invalidates it; the card
 * offers an explicit Recheck instead. The window rides the key because two
 * windows are two different answers, not two views of one.
 */
export const notificationDispatchKeys = {
  all: () => ["notifications", "dispatch-diagnostics"] as const,
  diagnostics: (windowDays: number) =>
    [...notificationDispatchKeys.all(), windowDays] as const,
};
